
import React from 'react';
import { RefreshCw } from 'lucide-react';

interface BackgroundRefreshButtonProps {
  onRefresh: () => void;
  isVisible: boolean;
}

const BackgroundRefreshButton: React.FC<BackgroundRefreshButtonProps> = ({ 
  onRefresh, 
  isVisible 
}) => {
  if (!isVisible) return null;

  const handleRefresh = () => {
    // Clear all background cache entries
    const keys = Object.keys(localStorage);
    const backgroundKeys = keys.filter(key => key.startsWith('timedUnsplash-'));
    backgroundKeys.forEach(key => localStorage.removeItem(key));
    
    console.log(`[Background] Cleared ${backgroundKeys.length} cached background entries`);
    onRefresh();
  };

  return (
    <button
      onClick={handleRefresh}
      className="fixed bottom-4 left-4 bg-white bg-opacity-20 hover:bg-opacity-30 backdrop-blur-sm border border-white border-opacity-30 text-white p-2 rounded-full transition-all duration-200 z-50"
      title="Refresh background image"
    >
      <RefreshCw className="w-4 h-4" />
    </button>
  );
};

export default BackgroundRefreshButton;
